var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 624,
    viewBox: "0 0 381 624",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "opacity-right-circle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 491.52,
    cy: 311.52,
    r: 306.96,
    stroke: "white",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 491.52,
    cy: 311.52,
    r: 399.12,
    stroke: "white",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 491.52,
    cy: 311.52,
    r: 491.28,
    stroke: "white",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 491.52,
    cy: 311.52,
    r: 122.64,
    stroke: "white",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 491.52,
    cy: 311.52,
    r: 214.8,
    stroke: "white",
    strokeWidth: 0.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCircles);
export default __webpack_public_path__ + "static/media/right_circles.123a80f6097987dbf046357f4de512b1.svg";
export { ForwardRef as ReactComponent };